// Haptic Feedback Utility using Capacitor Haptics with Web Vibration API fallback
import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

export type HapticType = 'light' | 'medium' | 'heavy' | 'selection' | 'success' | 'warning' | 'error';

export function triggerHaptic(type: HapticType = 'light'): void {
  try {
    // 1. Native Capacitor Haptics (True iOS Taptic Engine)
    if (Capacitor.isPluginAvailable('Haptics') || Capacitor.isNativePlatform()) {
      switch (type) {
        case 'light':
        case 'selection':
          Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
          break;
        case 'medium':
          Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {});
          break;
        case 'heavy':
          Haptics.impact({ style: ImpactStyle.Heavy }).catch(() => {});
          break;
        case 'success':
          Haptics.notification({ type: NotificationType.Success }).catch(() => {});
          break;
        case 'warning':
          Haptics.notification({ type: NotificationType.Warning }).catch(() => {});
          break;
        case 'error':
          Haptics.notification({ type: NotificationType.Error }).catch(() => {});
          break;
        default:
          Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {});
      }
      return;
    }
  } catch (err) {
    console.warn('[Haptics] Native haptic error:', err);
  }

  // 2. Web Vibration API Fallback
  if (typeof window !== 'undefined' && 'vibrate' in navigator) {
    try {
      switch (type) {
        case 'light':
        case 'selection':
          navigator.vibrate(15);
          break;
        case 'medium':
          navigator.vibrate(30);
          break;
        case 'heavy':
          navigator.vibrate(50);
          break;
        case 'success':
          navigator.vibrate([20, 50, 30]);
          break;
        case 'warning':
          navigator.vibrate([40, 70, 40]);
          break;
        case 'error':
          navigator.vibrate([50, 60, 50, 60, 50]);
          break;
        default:
          navigator.vibrate(25);
      }
    } catch {}
  }
}
